import React from 'react';
import { Panel, PanelPresets, UserPermissionsIds } from 'utility/enumerations';
import { ViewMounter } from '../view_mounter';
import { SecureRoute } from '../shared/secure_route';

function PhysicianContainerScreen() {
  return (
    <div>
      <SecureRoute
        path="/physician/my-profile"
        pathPermissionId={UserPermissionsIds.AccessMyPhysicianProfile}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/my_profile',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/physician/my-patients"
        pathPermissionId={UserPermissionsIds.AccessMyPatients}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/my_patients/my_patients',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/physician/my-patients/:dashboardStatus"
        pathPermissionId={UserPermissionsIds.AccessMyPatients}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/my_patients/my_patients',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/physician/add-patient"
        pathPermissionId={undefined}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/my_patients/add_patient/add_new_patient',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/physician/patient-profile/:id/:tab/:isnew"
        pathPermissionId={UserPermissionsIds.ReadPatient}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'physician/patient_management/patient_management',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/physician/certification_documentation/certification_doc_search"
        pathPermissionId={UserPermissionsIds.AccessCertificationDocumentation}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/certification_doc_search',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: { isAdmin: false },
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/physician/certification-doc/search-results/:type"
        pathPermissionId={UserPermissionsIds.AccessCertificationDocumentation}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/grid/certification_documentation_grid',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/physician/certification-doc/arf/:id"
        pathPermissionId={UserPermissionsIds.ReadCertificationDocumentation}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/certification_types/arf_documentation/arf_form.tsx',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/physician/certification-doc/skc/:id"
        pathPermissionId={UserPermissionsIds.ReadCertificationDocumentation}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/certification_types/skc_documentation/skc_form.tsx',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/physician/certification-doc/2pc/:id"
        pathPermissionId={UserPermissionsIds.ReadCertificationDocumentation}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/certification_types/2pc_documentation/2pc_form',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/physician/certification-doc/cmp/:id"
        pathPermissionId={UserPermissionsIds.ReadCertificationDocumentation}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/certification_types/cmp_documentation/cmp_form',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/physician/certification-doc/rfe/:id"
        pathPermissionId={UserPermissionsIds.ReadCertificationDocumentation}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/certification_types/rfe_documentation/rfe_form',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
    </div>
  );
}

export default PhysicianContainerScreen;
